import { useState } from "react"
import Pain from "./Pain.js";
import Tailor from "./Tailor.js";
import HowItWork from "./HowItWork.js";
import PricingStructure from "./PricingStructure.jsx";
import WhyMatanato from "./WhyMatanato.jsx";
import LeadForm from "./LeadForm.js";
import CTAB2b from "./CTAB2b.js";
import Vision from "./vision.js";
import WhoWeWork from "./WhoWeWork.js";
import IT from "./IT.js";
const logo = require("./images/MATANATO_LOGO.PNG");
const afc = require("./images/AFC.jpg");
const choice = require("./images/CHOICE.jpg");
const keepe = require("./images/Keepe.jpeg");
const cinch = require("./images/cinch.png");
const lg = require("./images/lg.png");
const hwa = require("./images/hwa.png");
const hsc = require("./images/hsc.jfif");
const hero = require("./images/hero.png");

const B2b = () => {

    const [state, setState] = useState(false)

    const navigation = [
        { title: "Technology & Infrastructure", path: "#it" },
        { title: "Tailored Solutions", path: "#tailor" },
        { title: "Pilot program", path: "#leadform" },

    ]

    return (
        <>
            <nav className="relative items-center pt-5 px-4 mx-auto max-w-screen-xl sm:px-8 md:flex md:space-x-6">
                <div className="flex justify-between">
                    <a href="/">
                        <img fetchpriority="low"
                                      src={logo}
                                      width={70}
                                      height={40}
                                      alt="Laborer Logo Matanato Home Services"
                        />
                    </a>
                    <button className="text-gray-500 outline-none md:hidden"
                        onClick={() => setState(!state)}
                    >
                        {
                            state ? (
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            ) : (

                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            )
                        }
                    </button>
                </div>
                <ul className={`flex-1 justify-between mt-12 md:text-sm md:font-medium md:flex md:mt-0 ${state ? 'absolute inset-x-0 px-4 border-b bg-white md:border-none md:static' : 'hidden'}`}>
                    <div className="items-center space-y-5 md:flex md:space-x-6 md:space-y-0 md:ml-12">
                        {
                            navigation.map((item, idx) => (
                                <li className="text-gray-500 hover:text-indigo-600" key={idx}>
                                    <a href={item.path}>{item.title}</a>
                                </li>
                            ))
                        }
                    </div>
                    <li className="order-2 py-5 md:py-0">
                        <a href="tel:+13468002250" className="py-2 px-5 rounded-lg font-medium text-white text-center bg-indigo-600 hover:bg-indigo-500 active:bg-indigo-700 duration-150 block md:py-3 md:inline">
                            Call Now!
                        </a>
                    </li>
                </ul>
            </nav>
            <section className="py-20">
                <div className="max-w-screen-xl mx-auto text-gray-600 gap-x-12 items-center justify-between overflow-hidden md:flex md:px-8">
                    <div className="flex-none space-y-5 px-4 sm:max-w-lg md:px-0 lg:max-w-xl">
                        <h1 className="text-sm text-indigo-600 font-medium">
                            Over 200 successful deals
                        </h1>
                        <h2 className="text-4xl text-gray-800 font-extrabold md:text-5xl">
                            Home Services Infrastructure for Modern Residential Communities
                        </h2>
                        <p>
                            We design and operate centralized home services systems that bring structure, reliability, and efficiency to large-scale residential developments.
                        </p>
                        <div className="items-center gap-x-3 space-y-3 sm:flex sm:space-y-0">
                            <a href="#leadform" className="block py-2 px-4 text-center text-white font-medium bg-indigo-600 duration-150 hover:bg-indigo-500 active:bg-indigo-700 rounded-lg shadow-lg hover:shadow-none">
                                Request a Consultation
                            </a>
                            <a href="https://drive.google.com/file/d/1JKOv2IUYDHts4aR7aP3NHLsJW2ty5eEq/view?usp=sharing" target="_blank" className="flex items-center justify-center gap-x-2 py-2 px-4 text-gray-700 hover:text-gray-500 font-medium duration-150 active:bg-gray-100 border rounded-lg md:inline-flex">
                                Download Capability Statement
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
                                    <path fillRule="evenodd" d="M2 10a.75.75 0 01.75-.75h12.59l-2.1-1.95a.75.75 0 111.02-1.1l3.5 3.25a.75.75 0 010 1.1l-3.5 3.25a.75.75 0 11-1.02-1.1l2.1-1.95H2.75A.75.75 0 012 10z" clipRule="evenodd" />
                                </svg>
                            </a>
                        </div>
                    </div>
                    <div className="flex-none mt-14 md:mt-0 md:max-w-xl">
                        <img
                            src={hero}
                            className=" md:rounded-tl-[108px]"
                            alt="B2B"
                        />
                    </div>
                </div>
                <div className="mt-14 px-4 md:px-8">
                    <p className="text-center text-sm text-gray-700 font-semibold">Based on operational models used in the United States. Trusted by</p>
                    <div className="flex justify-center items-center flex-wrap gap-x-12 gap-y-6 mt-6">
                    <img fetchpriority="low"
                                      src={afc}
                                      width={180}
                                      height={80}
                                      alt="AFC Home Warranty"
                                      className="border-none rounded-2xl shadow-xl"
                        />
                        <img fetchpriority="low"
                                      src={choice}
                                      width={120}
                                      height={40}
                                      alt="Choice Warranty"
                                      className="border-none rounded-2xl shadow-xl"
                        />
                        <img fetchpriority="low"
                                      src={keepe}
                                      width={120}
                                      height={40}
                                      alt="Keepe Up Inc"
                                      className="border-none rounded-2xl shadow-xl"
                        />
                        <img fetchpriority="low"
                                      src={cinch}
                                      width={120}
                                      height={40}
                                      alt="Cinch Home services"
                                      className="border-none rounded-2xl shadow-xl"
                        /><img fetchpriority="low"
                                      src={lg}
                                      width={120}
                                      height={40}
                                      alt="Line Guard Solutions"
                                      className="border-none rounded-2xl shadow-xl"
                        />
                        <img fetchpriority="low"
                                      src={hwa}
                                      width={120}
                                      height={40}
                                      alt="Home Warranty America"
                                      className="border-none rounded-2xl shadow-xl"
                        />
                        <img fetchpriority="low"
                                      src={hsc}
                                      width={120}
                                      height={40}
                                      alt="Home Services Club"
                                      className="border-none rounded-2xl shadow-xl"
                        />
                    </div>
                </div>
            </section>
            <Pain />
            <Vision />
             <IT />
            <WhoWeWork />
           
            <Tailor />
            <HowItWork />
            <PricingStructure />
            <WhyMatanato />
            <LeadForm />
            <CTAB2b />
        </>
    )
}

export default B2b;
